import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FxCurrencyPipe } from './pipes/fx-currency.pipe';
import { FxAvgRatingPipe } from './pipes/fx-avg-rating.pipe';
import { VarDirective } from './directives/ng-var.directive';
import { ProductTileComponent } from './components/product-tile/product-tile.component';


@NgModule({
  declarations: [
    FxCurrencyPipe,
    FxAvgRatingPipe,
    VarDirective,
    //
    ProductTileComponent
  ],
  imports: [
    CommonModule,
    FontAwesomeModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  exports: [
    CommonModule,
    FontAwesomeModule,
    FormsModule,
    ReactiveFormsModule,
    FxCurrencyPipe,
    FxAvgRatingPipe,
    VarDirective,
    //
    ProductTileComponent,
  ],
  providers: [
    FxCurrencyPipe,
    FxAvgRatingPipe,
    VarDirective
  ]
})
export class SharedModule { }
